module.exports = __webpack_public_path__ + "img/alipay_3.853aec5d.png";